export default __webpack_public_path__ + "static/media/avatar-s-7.59abbbc3.jpg";